{
  "name": "pokemon-auto-chess",
  "version": "6.11",
  "assetsVersion": "6.11.2026-08-15.0",
  "translationsVersion": "6.11-2026-08-17.0",
  "description": "Pokemon Auto Chess Game. Made by fans for fans. Open source, non profit. All rights to the Pokemon Company.",
  "keywords": [],
  "license": "BSD-3-Clause",
  "engines": {
    "node": "24.19.0",
    "npm": ">=10.8.1"
  },
  "homepage": "https://github.com/keldaanCommunity/pokemonAutoChess#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/keldaanCommunity/pokemonAutoChess.git"
  },
  "bugs": {
    "url": "https://github.com/keldaanCommunity/pokemonAutoChess/issues"
  },
  "author": "keldaan-ag",
  "contributors": [
    "ogus",
    "sylvainpolletvillard",
    "vinper",
    "tegberen"
  ],
  "main": "public/dist/server/app/index.js",
  "scripts": {
    "dev-client": "node esbuild.js --dev",
    "dev-server": "tsx watch ./app/index.ts",
    "dev": "npm-run-all --parallel dev-*",
    "lint": "npx @biomejs/biome lint app/",
    "format": "npx @biomejs/biome format app/ --write",
    "check": "npx @biomejs/biome check app/ --write",
    "check:unsafe": "npx @biomejs/biome check app/ --write --unsafe",
    "build-client": "node esbuild.js --build",
    "build-server": "tsc",
    "build-server-prod": "tsc --version && tsc -p tsconfig.prod.json --noCheck",
    "typecheck": "tsc --noEmit",
    "prebuild-server": "npm run clean-dist",
    "prebuild-server-prod": "npm run clean-dist",
    "clean-dist": "rimraf ./app/public/dist/server",
    "download-music": "degit --force https://github.com/keldaanCommunity/pokemonAutoChessMusic ./app/public/src/assets/musics",
    "build": "npm run build-client && npm run build-server",
    "build-prod": "npm run build-client && npm run build-server-prod",
    "start": "node ./app/public/dist/server/app/index.js",
    "postinstall": "npm run download-music && cd edit/assetpack && npm install",
    "assetpack": "cd edit/assetpack && npm run assetpack",
    "csv-export": "cd gen && tsx csv-export.ts",
    "check-labels": "cd gen && tsx check-labels.ts",
    "add-pokemon": "cd edit && tsx add-pokemon.ts",
    "colyseus-post-deploy": "npx colyseus-post-deploy",
    "deploy-live-1": "pm2 deploy production-1 update",
    "deploy-live-2": "pm2 deploy production-2 update",
    "deploy-live-3": "pm2 deploy production-3 update",
    "deploy-live-4": "pm2 deploy production-4 update",
    "deploy-live": "npm-run-all --parallel deploy-live-1 deploy-live-2 deploy-live-3 deploy-live-4",
    "setup-live-1": "pm2 deploy production-1 setup",
    "setup-live-2": "pm2 deploy production-2 setup",
    "setup-live-3": "pm2 deploy production-3 setup",
    "setup-live-4": "pm2 deploy production-4 setup",
    "setup-live": "npm-run-all --parallel setup-live-1 setup-live-2 setup-live-3 setup-live-4",
    "check-circular-refs": "npx dpdm ./app -T --no-warning --no-tree",
    "knip": "knip --max-show-issues 5"
  },
  "dependencies": {
    "@colyseus/command": "^0.3.1",
    "@colyseus/monitor": "^0.17.7",
    "@colyseus/msgpackr": "^1.11.2",
    "@colyseus/redis-driver": "^0.17.6",
    "@colyseus/redis-presence": "^0.17.6",
    "@colyseus/schema": "^4.0.28",
    "@colyseus/sdk": "^0.17.42",
    "@colyseus/tools": "^0.17.18",
    "@colyseus/ws-transport": "^0.17.9",
    "@reduxjs/toolkit": "^2.3.0",
    "colyseus": "^0.17.10",
    "cors": "^2.8.5",
    "cron": "^4.3.1",
    "d3": "^7.8.5",
    "dayjs": "^1.11.13",
    "discord.js": "^14.26.5",
    "dotenv": "^17.4.2",
    "express": "^5.2.1",
    "express-basic-auth": "^1.2.0",
    "fast-xml-parser": "^5.10.1",
    "firebase": "^10.0.0",
    "firebase-admin": "^13.9.0",
    "firebaseui": "^6.1.0",
    "fs-extra": "^11.3.5",
    "graceful-fs": "^4.2.10",
    "helmet": "^8.3.0",
    "html2canvas": "^1.4.1",
    "i18next": "^26.3.6",
    "i18next-browser-languagedetector": "^8.0.0",
    "i18next-http-backend": "^4.0.0",
    "immer": "^11.1.15",
    "jimp": "^1.6.0",
    "loglevel": "^1.8.1",
    "markdown-to-config": "^0.4.0",
    "marked": "^18.0.6",
    "matter-js": "^0.20.0",
    "mongoose": "^9.6.2",
    "phaser": "^4.2.1",
    "phaser4-rex-plugins": "^4.0.6",
    "pm2-prom-module-client": "^1.0.3",
    "prom-client": "^15.1.1",
    "react": "^19.2.6",
    "react-circular-progressbar": "^2.1.0",
    "react-dom": "^19.2.6",
    "react-i18next": "^17.0.10",
    "react-pro-sidebar": "^1.1.0",
    "react-redux": "^9.1.2",
    "react-router": "^8.3.0",
    "react-tabs": "^6.0.2",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.2",
    "react-virtualized-auto-sizer": "^2.0.3",
    "react-window": "^2.2.7",
    "recharts": "^3.6.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.15",
    "@types/cors": "^2.8.17",
    "@types/d3": "^7.4.3",
    "@types/fs-extra": "^11.0.4",
    "@types/matter-js": "^0.20.0",
    "@types/node": "^24.12.0",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "csv-writer": "^1.6.0",
    "degit": "^3.6.1",
    "esbuild": "^0.28.0",
    "knip": "^6.26.0",
    "npm-run-all2": "^8.0.0",
    "pm2": "^7.0.3",
    "rimraf": "^6.1.3",
    "tsx": "^4.23.1",
    "typescript": "^7.0.2"
  }
}